<div class="container mx-auto py-4">
    <label class="text-[1rem] font-bold !mb-4 text-[#21252A]">Change History</label>
    <div class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-300">
        <thead>
          <tr class="bg-[#D9D9D9] text-[#21252A]  text-[18px] leading-normal">
            <th class="py-3 px-6 text-left">Date</th>
            <th class="py-3 px-6 text-left">Action By</th>
            <th class="py-3 px-6 text-left">Changed</th>
            <th class="py-3 px-6 text-left">From</th>
            <th class="py-3 px-6 text-left">To</th>
          </tr>
        </thead>
        <tbody class="text-[#343A40] text-[1rem] font-medium font-roboto">
          <tr *ngFor="let change of changeHistory" class="border-b border-gray-200 hover:bg-gray-100">
            <td class="py-3 px-6 text-left whitespace-nowrap">{{ change.date }}</td>
            <td class="py-3 px-6 text-left">{{ change.actionBy }}</td>
            <td class="py-3 px-6 text-left">{{ change.changed }}</td>
            <td class="py-3 px-6 text-left">{{ change.from }}</td>
            <td class="py-3 px-6 text-left">{{ change.to }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>